import {Tile} from './tile';
import {Vector} from './vector';
import {Layers} from './layers';
import {Heatmap} from './heatmap';
import {Image} from './image';
import {VectorTile} from './vector-tile';
import { Graticule } from './graticule';

let layer = {
  Tile: Tile,
  Vector: Vector,
  Heatmap: Heatmap,
  Image: Image,
  VectorTile: VectorTile,
  Graticule: Graticule,
};

export { 
  Layers,
  layer,
  Heatmap,
  Image,
  VectorTile,
  Graticule,
};
